module.exports = "https://static.energy5.com/_next/static/images/gasBg-a6c4f0b54f730acf85110a15d7944325.webp";